module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8726263c2a7d24e22ecc662ed3ac70eb.png";